import dayjs from 'dayjs';
import { theme } from '@frontend/theme';
import { SearchField, Text, useFormField, DropdownField, DateRangeField, CheckboxField } from '@frontend/design-system';

export const FiltersTable = () => {
  const searchField = useFormField({ type: 'text' });
  const datesRangeProps = useFormField(
    {
      type: 'dateRange',
      value: [dayjs(new Date()).format('MM/DD/YYYY'), dayjs(new Date()).format('MM/DD/YYYY')],
      maxDate: dayjs(new Date()).format('YYYY-MM-DD'),
    },
    []
  );

  const removeProps = useFormField({
    type: 'checkbox',
    value: false,
  });
  const reviewProps = useFormField({
    type: 'checkbox',
    value: false,
  });
  const testProps = useFormField({
    type: 'checkbox',
    value: false,
  });
  const userProps = useFormField({
    type: 'dropdown',
    value: '',
  });

  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
      <div css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text weight='bold'>Search</Text>
        <Text color={`${searchField.value ? 'light' : 'disabled'}`} weight='bold'>
          Clear
        </Text>
      </div>
      <SearchField name='search-field' {...searchField} placeholder='Search by name, description, or status' />
      <Text weight='bold'>Date Created</Text>
      <TimePeriodSelector />
      <DateRangeField {...datesRangeProps} label='' name='date-range' />
      <Text weight='bold' css={{ marginTop: theme.spacing(3) }}>
        Flag Status
      </Text>
      <CheckboxField {...removeProps} label='Remove' name='remove-flags' />
      <CheckboxField {...reviewProps} label='Review' name='review-flags' />
      <CheckboxField {...testProps} label='Test' name='test-flags' />
      <Text weight='bold' css={{ marginTop: theme.spacing(3) }}>
        Flag Created
      </Text>
      <DropdownField {...userProps} name='select-user' label='Type Flag Creator'>
        {['Pablo Trujillo', 'Eric Gish', 'Alo Tauaese', 'Daniel Farr', 'Kevin Ung', 'Keaton Gallagher'].map((label) => {
          return (
            <DropdownField.Option key={label} value={label}>
              {label}
            </DropdownField.Option>
          );
        })}
      </DropdownField>
    </div>
  );
};

export const TimePeriodSelector = () => {
  const daysFieldProps = useFormField({
    type: 'dropdown',
    value: '',
  });

  return (
    <DropdownField {...daysFieldProps} label={'Select Time Period'} name='days' placeholder={'Select Time Period'}>
      {['Last 30 Days', 'Last 7 Days', 'Last 6 Months'].map((label) => {
        return (
          <DropdownField.Option key={label} value={label}>
            {label}
          </DropdownField.Option>
        );
      })}
    </DropdownField>
  );
};
